import { useState, useEffect } from 'react';
import { useAuth } from "../../contexts/AuthContext";
import { useNavigate } from "react-router";
import { db } from "../../firebase";
import { doc, getDoc } from "firebase/firestore";
import * as theme from '../../theme';
import PractitionerList from '../../components/dashboards/lists/PractitionerList';
import PreScanFormsList from '../../components/dashboards/lists/PreScanFormsList';
import Schedule from '../../components/Schedule';
import OnboardingStatusList from '../../components/dashboards/lists/OnboardingStatusList';
import ActiveScanList from '../../components/dashboards/lists/ActiveScanList';
import TBResourceList from '../../components/dashboards/lists/TBResourceList';
import InboxUnreadsList from '../../components/dashboards/lists/InboxUnreadsList';
import WhatsNewCard from '../../components/WhatsNewCard';

export default function AdminDashboard() {
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const [practitionerList, setPractitionerList] = useState([]);
  const [preScanFormsList, setPreScanFormsList] = useState([]);
  const [activeScansList, setActiveScansList] = useState([]);
  const [clientMapList, setClientMapList] = useState([]);
  const [inboxUnreads, setInboxUnreads] = useState([]);

  useEffect(() => {
    if (practitionerList.length == 0) {
      getManagementData();
      getActiveScansData();
      getClientMapData();
      getInboxData();
    }
  }, [practitionerList]);

  async function getManagementData() {
    try {
      const docRef = doc(db, "app", 'management');
      const docSnap = await getDoc(docRef);
      const data = docSnap.data();
      setPractitionerList(data.practitioners || []);
      setPreScanFormsList(data.preScanForms || []);
    } catch (err) {
      console.log(err.message);
    }
  }

  async function getActiveScansData() {
    try {
      const docRef = doc(db, "app", 'activeScans');
      const docSnap = await getDoc(docRef);
      const data = docSnap.data();
      setActiveScansList(data.scans || []);
    } catch (err) {
      console.log(err.message);
    }
  }

  async function getClientMapData() {
    try {
      const docRef = doc(db, "app", 'clientMap');
      const docSnap = await getDoc(docRef);
      const data = docSnap.data();
      setClientMapList(data.clients || []);
    } catch (err) {
      console.log(err.message);
    }
  }

  async function getInboxData() {
    try {
      const docRef = doc(db, "app", 'inbox');
      const docSnap = await getDoc(docRef);
      const data = docSnap.data();
      setInboxUnreads(data.unreads || []);
    } catch (err) {
      console.log(err.message);
    }
  }

  return (
    <div style={theme.Container.flexColumn}>
      <div style={theme.Container.fullMax}>
        <div style={theme.Container.flexOne}>
          <Schedule />
        </div>
      </div>
      <div style={{ ...theme.Container.fullMax, marginTop: 20 }}>
        <div style={theme.Container.flexOne}>
          <PractitionerList practitionerList={practitionerList} />
        </div>
        <div style={theme.Container.flexOne}>
          <div style={{ ...theme.Container.flexColumn, flex: 1, gap: 20 }}>
            <InboxUnreadsList practitionerList={practitionerList} unreads={inboxUnreads} />
            <ActiveScanList activeScansList={activeScansList} clientList={clientMapList} practitionerList={practitionerList} />
            <OnboardingStatusList practitionerList={practitionerList} />
          </div>
        </div>
        <div style={theme.Container.flexOne}>
          <div style={{ ...theme.Container.flexColumn, flex: 1, gap: 20 }}>
            <WhatsNewCard />
            <TBResourceList />
            <PreScanFormsList preScanFormsList={preScanFormsList} />
          </div>
        </div>
      </div>
    </div>
  );
}